export const perc = (value, total) => {
    return ((value / total) * 100).toFixed(2);
};
